import React from 'react';
import { ColumnsType } from 'antd/es/table';

import { TagTable } from 'components/components';
import { VentureBuilderListItemType } from 'packages/venture_builder_repository';
import { parseNumberToPrice } from 'utils/helpers/priceFormatters';
import NOT_SPECIFIED from 'utils/constants/display';

const ventureBuildersColumns: ColumnsType<VentureBuilderListItemType> = [
  {
    key: 'name',
    title: 'Venture Builder',
    dataIndex: 'name',
    render: (value: string) => value || NOT_SPECIFIED,
  },
  {
    key: 'email',
    title: 'Email',
    dataIndex: 'email',
    render: (value: string) => <div className="table-email-column">{value || NOT_SPECIFIED}</div>,
  },
  {
    key: 'contact',
    title: 'Contact name',
    dataIndex: 'fullName',
    render: (value: string) => value || NOT_SPECIFIED,
  },
  {
    key: 'startupsCount',
    title: 'Startups',
    dataIndex: 'startupsCount',
  },
  {
    key: 'walletAmount',
    title: 'Wallet per startup',
    dataIndex: 'walletAmount',
    render: (value: number) => (value >= 0 ? parseNumberToPrice(value, 'AED') : NOT_SPECIFIED),
  },
  {
    key: 'status',
    title: 'Status',
    dataIndex: 'active',
    render: (active: boolean) => (
      <TagTable text={active ? 'Active' : 'Inactive'} color={active ? 'success' : 'error'} />
    ),
  },
];

export default ventureBuildersColumns;
